// @flow
import React, {useState, useMemo, useEffect} from 'react';
import {
  Tab,
  Tabs,
  makeStyles,
  Divider,
  Typography,
  IconButton,
  Chip,
  Snackbar,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import {colors} from '../../../../../assets/styles/colors';
import {Add, Tune, ArrowBack, Close} from '@material-ui/icons';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {useLocation, Link, Switch, Route} from 'react-router-dom';
import LogisticShippingNational from './LogisticShippingNational';
import LogisticShippingInternational from './LogisticShippingInternational';
import CardEstandarShipping from './components/CardEstandarShipping';
import {
  useCRUDStandardRate,
  useDataShippingEstandar,
  useFetchShippingMethods,
  useGetCurrencyCountry,
  useResetState,
} from '../utils';
import {useCountries} from '../../../../../modules/country/utils';
import {useStoreCountry} from '../../../../country/utils';
import FilterModalShipping from '../../logistics/components/FilterModalShipping';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#fff',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },
  subRouteHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingBlock: theme.spacing(2),
    paddingInline: theme.spacing(2),
    borderTop: '1px solid #dbdbe0',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
    borderLeft: '1px solid #dbdbe0',
    borderRight: '1px solid #dbdbe0',
  },
  subRouteTitle: {
    marginLeft: theme.spacing(1),
    fontSize: '1rem',
    fontWeight: 600,
  },
  contentBackground: {
    backgroundColor: '#fcfcfd',
    borderRadius: '12px',
    border: '1px solid #dbdbe0',
  },
  contentTabs: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tabs: {
    width: 'fit-content',
  },
  tabButton: {
    color: colors.grey600,
    textTransform: 'none',
  },
  tabSelected: {
    color: colors.grey900,
    textTransform: 'none',
  },
  divider: {
    background: '#e8e8ed',
    width: '100%',
    // marginBottom: theme.spacing(2),
  },
  newRate: {
    marginBottom: theme.spacing(1),
    width: '100%',
    border: `2px dashed ${colors.grey300}`,
    borderRadius: '8px',
    paddingBlock: theme.spacing(1),
    paddingInline: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    color: colors.grey700,
    fontWeight: 400,
  },
  backgroundButton: {
    backgroundColor: colors.grey300,
    borderRadius: '50%',
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  filterButton: {
    background: 'transparent',
    border: '1px solid #E0E0E0',
    color: colors.grey600,
    paddingInline: theme.spacing(2),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  containerNational: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  containerInternational: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  containerData: {
    backgroundColor: '#f9f9fb',
    borderRadius: '8px',
    padding: theme.spacing(2),
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    borderRadius: '8px',
    gap: theme.spacing(1),
  },
  textGrey: {
    color: colors.grey600,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  buttonsHeader: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  bold: {
    fontWeight: 600,
  },
  check: {
    backgroundColor: '#ccf0e6',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    height: '19px',
    width: '19px',
    padding: '12px',
    justifyContent: 'center',
    cursor: 'pointer',

    '& svg': {
      color: '#007f5d',
      fontSize: '19px',
      fontWeight: 600,
    },
  },
  notCheck: {
    padding: '11px',
    backgroundColor: '#ffffff',
    border: '1px solid #d4d4dd',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    height: '19px',
    width: '19px',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  deleteButton: {
    color: colors.error,
  },
  editButton: {
    color: colors.grey600,
  },
  chipCountry: {
    backgroundColor: colors.grey300,
    color: colors.grey700,
    padding: theme.spacing(1),
    borderRadius: '8px',
    width: 'fit-content',
    fontWeight: 600,
    height: '25px',
    textTransform: 'uppercase',
  },
  chipCountryNotFound: {
    backgroundColor: colors.error,
    color: 'white',
    padding: theme.spacing(1),
    borderRadius: '8px',
    width: 'fit-content',
    fontWeight: 600,
    height: '25px',
    textTransform: 'uppercase',
  },
  containerBackground: {
    paddingTop: theme.spacing(2),
    paddingInline: theme.spacing(2),
    paddingBottom: '22px',
    borderLeft: '1px solid #dbdbe0',
    borderRight: '1px solid #dbdbe0',
    borderBottom: '1px solid #dbdbe0',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },
  containerZone: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1),
  },
  zoneNotConfig: {
    color: colors.error,
    fontSize: '0.8rem',
  },
}));

type SubRoute = {
  name: string,
  path: string,
  enabled?: boolean,
  disabled?: boolean,
  component?: () => any,
  id?: string,
  hide?: boolean,
  id2?: string,
};

export default function LogisticsShippingStardard() {
  const classes = useStyles();
  const location = useLocation();

  const country = useStoreCountry();
  const countries = useCountries();
  const [tabValue, setTabValue] = useState('national');
  const [addresses, setAddresses] = useState();
  const [filter, setFilter] = useState({});
  const [alertOpen, setAlertOpen] = useState(false);
  const [, setAlertOpenError] = useState(false);
  const [openModalFilter, setOpenModalFilter] = useState(false);
  const {shippingDataEstandar} = useDataShippingEstandar();
  const {availableShippingCountries} = useFetchShippingMethods();
  const currency = useGetCurrencyCountry();
  const {
    isSaving,
    savingStandardRateSuccess,
    savingStandardRateError,
  } = useCRUDStandardRate();
  const {resetState} = useResetState();

  const handleCloseModal = () => {
    setOpenModalFilter(false);
  };

  const handleFilter = filter => {
    setFilter(filter);
  };

  const existingCountryCodes =
    shippingDataEstandar && shippingDataEstandar.map(data => data.country.code);

  const countriesAvailableToAdd = availableShippingCountries.filter(
    country => !existingCountryCodes.includes(country.code)
  );

  const isCountryAvailable = countryCode => {
    return availableShippingCountries.some(
      country => country.code === countryCode
    );
  };

  const isAvailableOtherCountries =
    availableShippingCountries &&
    availableShippingCountries.filter(
      countryI => countryI.code !== country?.code
    ).length > 0;

  const subRoutes: {[key: string]: SubRoute} = useMemo(
    () => ({
      national: {
        name: 'Agregar tarifa nacional',
        path: '/configure/logistics/shipping/standard/national/new',
        component: LogisticShippingNational,
        id: 'standard-shipping-national',
        id2: 'standard-shipping-configuration',
      },
      international: {
        name: 'Agregar tarifa internacional',
        path: '/configure/logistics/shipping/standard/international/new',
        component: LogisticShippingInternational,
        id: 'standard-shipping-international',
        id2: 'standard-shipping-configuration',
      },
    }),
    []
  );

  const subRoutesArray = Object.keys(subRoutes)
    .map(k => subRoutes[k])
    .filter((route: SubRoute) => !route.hide);

  const subRoute: ?SubRoute = subRoutesArray.find(
    (route: SubRoute) => location.pathname === route.path
  );

  const passesFilter = (rate, filter) => {
    if (!filter || Object.keys(filter).length === 0) {
      return true;
    }

    if (filter.countryCode && filter.countryCode !== rate.country.code) {
      return false;
    }

    if (filter.admin1 && filter.admin1.adminId) {
      if (rate.admin1.admin1Id !== filter.admin1.adminId) {
        return false;
      }
    }

    if (filter.admin2 && filter.admin2.adminId) {
      if (rate.admin2.admin2Id !== filter.admin2.adminId) {
        return false;
      }
    }

    if (filter.admin3 && filter.admin3.adminId) {
      if (rate.admin3.admin3Id !== filter.admin3.adminId) {
        return false;
      }
    }

    return true;
  };

  useEffect(() => {
    const totalAddress = {};
    if (shippingDataEstandar) {
      shippingDataEstandar.forEach(address => {
        const countryCode = address.country.code;
        if (!totalAddress[countryCode]) {
          totalAddress[countryCode] = [];
        }
        totalAddress[countryCode].push(address);
      });
    }
    setAddresses(totalAddress);
  }, [country, shippingDataEstandar]);

  useEffect(() => {
    if (savingStandardRateError) {
      setAlertOpenError(true);
    }
  }, [savingStandardRateError]);

  useEffect(() => {
    if (savingStandardRateSuccess) {
      setAlertOpen(true);
    }
  }, [savingStandardRateSuccess]);

  useEffect(() => {
    return () => {
      resetState();
    };
  }, [resetState]);

  const existRateNational =
    shippingDataEstandar &&
    country &&
    shippingDataEstandar.some(item => item.country.code === country.code);

  return (
    <div className={classes.root}>
      <Snackbar
        open={alertOpen}
        autoHideDuration={4000}
        onClose={() => setAlertOpen(false)}
      >
        <Alert severity="success" onClose={() => setAlertOpen(false)}>
          Configuración guardada correctamente
        </Alert>
      </Snackbar>
      {subRoute && (
        <div className={classes.subRouteHeader}>
          <IconButton
            variant="contained"
            size="small"
            component={Link}
            to={`/configure/logistics/shipping/standard${window.location.search}`}
          >
            <ArrowBack />
          </IconButton>
          <Typography className={classes.subRouteTitle} id={subRoute.id2}>
            {subRoute.name}
          </Typography>
        </div>
      )}

      <Switch>
        <Route exact path="/configure/logistics/shipping/standard">
          <div className={classes.containerBackground}>
            <div className={classes.contentBackground}>
              <div className={classes.contentTabs}>
                <Tabs
                  value={tabValue}
                  onChange={(event, newValue) => setTabValue(newValue)}
                  aria-label=""
                  className={classes.tabs}
                  variant="fullWidth"
                  indicatorColor="primary"
                >
                  <Tab
                    className={`${classes.tabButton} ${
                      tabValue === 'national' ? classes.tabSelected : ''
                    }`}
                    value="national"
                    label="Nacionales"
                  />
                  <Tab
                    disabled={!isAvailableOtherCountries}
                    className={`${classes.tabButton} ${
                      tabValue === 'international' ? classes.tabSelected : ''
                    }`}
                    value="international"
                    label="Internacionales"
                  />
                </Tabs>
                {tabValue === 'international' && (
                  <div className={classes.buttonsHeader}>
                    {Object.keys(filter).length > 0 && (
                      <CustomButton
                        className={classes.filterButton}
                        color="default"
                        startIcon={<Close />}
                        onClick={() => setFilter({})}
                      >
                        Borrar filtros
                      </CustomButton>
                    )}

                    <CustomButton
                      className={classes.filterButton}
                      color="default"
                      startIcon={<Tune />}
                      onClick={() => setOpenModalFilter(true)}
                    >
                      Filtros
                    </CustomButton>
                  </div>
                )}
              </div>

              <Divider className={classes.divider} />

              <div className={classes.container}>
                <div className={classes.containerNational}>
                  {tabValue === 'national' &&
                    addresses &&
                    country &&
                    addresses[country.code] &&
                    addresses[country.code]
                      .filter(rate => passesFilter(rate, filter))
                      .map(rate => (
                        <CardEstandarShipping
                          isNational={tabValue === 'national'}
                          rate={rate}
                          classes={classes}
                          key={rate.id}
                          isEditable={true}
                          currency={currency}
                        />
                      ))}

                  {tabValue === 'international' && addresses && countries && (
                    <div className={classes.containerInternational}>
                      {countries
                        .filter(countryII => countryII.code !== country.code)
                        .filter(countryI =>
                          addresses[countryI.code]?.some(rate =>
                            passesFilter(rate, filter)
                          )
                        )
                        .map(countryI => (
                          <div
                            className={classes.containerInternational}
                            key={`country-internationalI-${countryI.code}`}
                          >
                            <div className={classes.containerZone}>
                              <Chip
                                label={countryI.name}
                                className={
                                  isCountryAvailable(countryI.code)
                                    ? classes.chipCountry
                                    : classes.chipCountryNotFound
                                }
                                key={`country-international-${countryI.code}`}
                              />
                              {!isCountryAvailable(countryI.code) && (
                                <Typography className={classes.zoneNotConfig}>
                                  Esta zona de reparto no está configurada
                                </Typography>
                              )}
                            </div>
                            {addresses[countryI.code]
                              .filter(rate => passesFilter(rate, filter))
                              .map(rate => (
                                <CardEstandarShipping
                                  isNational={tabValue === 'national'}
                                  rate={rate}
                                  classes={classes}
                                  key={`international-${rate.id}`}
                                  isEditable={isCountryAvailable(countryI.code)}
                                  currency={currency}
                                />
                              ))}
                          </div>
                        ))}
                      {countries
                        .filter(countryII => countryII.code !== country.code)
                        .every(
                          countryI =>
                            !addresses[countryI.code]?.some(rate =>
                              passesFilter(rate, filter)
                            )
                        ) && (
                        <>
                          {Object.keys(filter).length > 0 && (
                            <div className={classes.noResults}>
                              No se encontraron resultados
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>

                {tabValue === 'national' && !existRateNational && (
                  <CustomButton
                    classes={{
                      root: classes.newRate,
                    }}
                    color="default"
                    startIcon={
                      <div className={classes.backgroundButton}>
                        <Add />
                      </div>
                    }
                    to={`/configure/logistics/shipping/standard/national/new`}
                    disabled={isSaving}
                  >
                    Agregar una tarifa
                  </CustomButton>
                )}

                {tabValue === 'international' &&
                  countriesAvailableToAdd.length > 0 && (
                    <CustomButton
                      classes={{
                        root: classes.newRate,
                      }}
                      color="default"
                      startIcon={
                        <div className={classes.backgroundButton}>
                          <Add />
                        </div>
                      }
                      to={`/configure/logistics/shipping/standard/international/new`}
                      disabled={isSaving}
                    >
                      Agregar una tarifa
                    </CustomButton>
                  )}
              </div>
            </div>
          </div>
        </Route>
        {subRoutesArray.map((route: SubRoute, idx: number) => (
          <Route key={idx} path={route.path} component={route.component} />
        ))}

        <Route path="/configure/logistics/shipping/standard/national/:adminRateId">
          <div className={classes.subRouteHeader}>
            <IconButton
              variant="contained"
              size="small"
              component={Link}
              to={`/configure/logistics/shipping/standard${window.location.search}`}
            >
              <ArrowBack />
            </IconButton>
            <Typography className={classes.subRouteTitle}>
              {tabValue === 'national'
                ? 'Editar tarifa nacional'
                : 'Editar tarifa internacional'}
            </Typography>
          </div>
          <Divider className={classes.divider} />
          <LogisticShippingNational />
        </Route>
        <Route path="/configure/logistics/shipping/standard/international/:adminRateId">
          <div className={classes.subRouteHeader}>
            <IconButton
              variant="contained"
              size="small"
              component={Link}
              to={`/configure/logistics/shipping/standard${window.location.search}`}
            >
              <ArrowBack />
            </IconButton>
            <Typography className={classes.subRouteTitle}>
              {tabValue === 'international'
                ? 'Editar tarifa internacional'
                : 'Editar tarifa nacional'}
            </Typography>
          </div>
          <Divider className={classes.divider} />
          <LogisticShippingInternational />
        </Route>
      </Switch>

      <FilterModalShipping
        typeFilter={tabValue}
        open={openModalFilter}
        handleCloseModal={handleCloseModal}
        handleFilter={handleFilter}
        onlyCountries={true}
        ignoreStoreCountryP={tabValue === 'national' ? false : true}
        filterIsEmpty={Object.keys(filter).length === 0}
        availableShippingCountries={availableShippingCountries}
      />
    </div>
  );
}
